// The /signup guard's destination for a signed-in user who already has a
// workspace (App.js, D-04). Without a promotion code: the app home, exactly as
// before. With one: the Billing tab's upgrade modal, so a Free owner who
// scanned an event QR code still gets the offer (docs/promo-codes.md).

import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { signupRedirectTarget } from '../../../utils/promoCode';

export default function SignupRedirect() {
    const { search } = useLocation();
    return <Navigate to={signupRedirectTarget(search)} replace />;
}
